'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import { createContext, useContext, useEffect, useState } from 'react';
import tunnel from 'tunnel-rat';
import { create } from 'zustand';
import { useDeviceDetection } from '~/hooks/use-device-detection';
import s from './webgl.module.css';
const WebGLCanvas = dynamic(() => import('./webgl').then(({
  WebGLCanvas
}) => WebGLCanvas), {
  ssr: false
});
const useRoot = create(() => ({}));
export const CanvasContext = createContext({});
export function Canvas(t0) {
  const $ = _c(28);
  let children;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      children,
      root: t1,
      force: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    children = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const root = t1 === undefined ? false : t1;
  const force = t2 === undefined ? false : t2;
  const [WebGLTunnel] = useState(_temp);
  const [DOMTunnel] = useState(_temp2);
  const {
    isWebGL
  } = useDeviceDetection();
  let t3;
  let t4;
  if ($[5] !== DOMTunnel || $[6] !== WebGLTunnel || $[7] !== force || $[8] !== isWebGL || $[9] !== root) {
    t3 = () => {
      if (root) {
        useRoot.setState(isWebGL || force ? {
          WebGLTunnel,
          DOMTunnel
        } : {});
      }
      return _temp3;
    };
    t4 = [root, isWebGL, force, WebGLTunnel, DOMTunnel];
    $[5] = DOMTunnel;
    $[6] = WebGLTunnel;
    $[7] = force;
    $[8] = isWebGL;
    $[9] = root;
    $[10] = t3;
    $[11] = t4;
  } else {
    t3 = $[10];
    t4 = $[11];
  }
  useEffect(t3, t4);
  let t5;
  if ($[12] !== DOMTunnel || $[13] !== WebGLTunnel || $[14] !== force || $[15] !== isWebGL) {
    t5 = isWebGL || force ? {
      WebGLTunnel,
      DOMTunnel
    } : {};
    $[12] = DOMTunnel;
    $[13] = WebGLTunnel;
    $[14] = force;
    $[15] = isWebGL;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== force || $[18] !== isWebGL || $[19] !== props) {
    t6 = (isWebGL || force) && <WebGLCanvas {...props} />;
    $[17] = force;
    $[18] = isWebGL;
    $[19] = props;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== props || $[22] !== t6) {
    t7 = <div id="webgl" className={s.webgl} {...props}>{t6}</div>;
    $[21] = props;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== children || $[25] !== t5 || $[26] !== t7) {
    t8 = <CanvasContext.Provider value={t5}>{t7}{children}</CanvasContext.Provider>;
    $[24] = children;
    $[25] = t5;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  return t8;
}
function _temp3() {
  useRoot.setState({});
}
function _temp2() {
  return tunnel();
}
function _temp() {
  return tunnel();
}
export function useCanvas() {
  const local = useContext(CanvasContext);
  const root = useRoot();
  const isLocalDefined = Object.keys(local).length > 0;
  return isLocalDefined ? local : root;
}